import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={26.474}
    height={21.727}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 52760 43299"
    {...props}
  >
    <path
      d="M3645 27930h15941c-1465 6285-11636 8020-15418 1306-312-553-298-803-523-1306zm29529 0h15941c-394 820-593 1437-1154 2243-507 729-1054 1214-1713 1684-5233 3745-12004 666-13074-3927zM5736 3104h19337v31620c0 6285-10477 7669-12020 1046 3856-321 6979-2996 8540-6355 270-581 473-1083 647-1706 196-708 169-1480 482-2130H771c110 4959 4883 10191 9930 10191 368 4427 6789 9005 12635 5580 980-574 2489-1867 2783-2967h522c671 2509 6913 6631 12590 2137 1070-846 2689-3075 2828-4750 5113 0 9817-5079 9931-10191H30038c356 739 199 1011 427 1925 1061 4274 5156 8175 9243 8266-1594 6842-12021 5270-12021-1046V3104h19337V753H5736v2351z"
      style={{
        // fill: "#000",
        // stroke: "#2b2a29",
        strokeWidth: 1506.44,
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
